import React from 'react';
import { SERVICE_DESK_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import ReporterEdit from '@atlassian/jira-issue-field-reporter/src/ui/edit/index.tsx';
import type { FieldValue } from '../../common/ui/fields/base-fields/user-picker-field/types.tsx';
import { transformJiraUserToUserOption } from '../../common/ui/fields/base-fields/user-picker-field/utils.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { validateUserPickerField } from '../../common/utils/validators/index.tsx';
import type { Props, ReporterFieldConfig } from './types.tsx';

const ReporterField = (props: Props) => {
	const {
		width,
		fieldProps: { value, onChange, ...fieldProps },
		autoFocus = false,
		isRequired,
		isReadOnly = false,
		selectedProject,
	} = props;

	const { projectType, projectKey } = selectedProject || {};

	return (
		<FieldContainer width={width}>
			{/* @ts-expect-error - TS2741 - Property 'fieldId' is missing in type '{ value: LegacyValue<UserOption>; onChange: (value: LegacyValue<UserOption>) => void; appearance: "normal"; autoCompleteUrl: string; isMulti: false; autoFocus: boolean; isClearable: boolean; allowEmail: boolean; }' but required in type 'UserPickerProps'. */}
			<ReporterEdit
				{...fieldProps}
				value={value}
				onChange={onChange}
				appearance="normal"
				isDisabled={isReadOnly}
				autoCompleteUrl={`/rest/api/3/user/recommend?${new URLSearchParams({
					context: 'Reporter',
					...(projectKey && { project: projectKey }),
					query: '',
				})}`}
				isMulti={false}
				autoFocus={autoFocus}
				isClearable={!isRequired}
				allowEmail={projectType === SERVICE_DESK_PROJECT}
				width={width}
				inputId={fieldProps.id}
				openMenuOnClick
			/>
		</FieldContainer>
	);
};

export default withFormField({
	validator: validateUserPickerField,
	transformDefaultValue: transformJiraUserToUserOption,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ReporterFieldConfig, LegacyValue<UserOption>>, any>'.
})<ReporterFieldConfig, FieldValue>(ReporterField);
